import { getSnackbarMessage } from '@/utils/common'
import { AlteracaoProfissionalRepasseResponse } from '@/types/interfaces/AlteracaoProfissionalRepasse'

const MENSAGEM_SEM_RESUMO = 'Profissional alterado com sucesso!'

const listMotivosRecusa = (resultado: AlteracaoProfissionalRepasseResponse): string[] => {
  const motivos = resultado.itens
    .filter(item => item.resultadoEnum === 'recusado' && item.motivo)
    .map(item => item.motivo as string)

  return Array.from(new Set(motivos))
}

const buildTextoRecusa = (resultado: AlteracaoProfissionalRepasseResponse): string => {
  const motivos = listMotivosRecusa(resultado)

  if (motivos.length === 0) {
    return resultado.mensagem
  }

  if (resultado.itens.length === 1) {
    return `Item recusado: ${motivos[0]}`
  }

  const rotulo = motivos.length === 1 ? 'Motivo' : 'Motivos'

  return `${resultado.mensagem} ${rotulo}: ${motivos.join('; ')}`
}

// O backend devolve um resultado por item: alterado na hora, enviado para recálculo ou recusado.
const buildSnackbarAlteracaoProfissional = (resultado?: AlteracaoProfissionalRepasseResponse) => {
  if (!resultado || !resultado.itens) {
    return getSnackbarMessage(MENSAGEM_SEM_RESUMO, 'success')
  }

  if (resultado.totalRecusados === 0) {
    return getSnackbarMessage(resultado.mensagem, 'success')
  }

  return {
    ...getSnackbarMessage(buildTextoRecusa(resultado), 'error'),
    multiLine: true,
    dismissible: true,
  }
}

export default buildSnackbarAlteracaoProfissional
